import axios from 'axios';

const api = axios.create({
  baseURL: "https://api.rndsan.com/api/api"
//baseURL: "http://192.168.29.250:9998/api"
});

export default api;